import { render, staticRenderFns } from "./EditEduDetails.vue?vue&type=template&id=56a09b26&scoped=true"
import script from "./EditEduDetails.vue?vue&type=script&lang=js"
export * from "./EditEduDetails.vue?vue&type=script&lang=js"
import style0 from "./EditEduDetails.vue?vue&type=style&index=0&id=56a09b26&prod&scoped=true&lang=css"
import style1 from "./EditEduDetails.vue?vue&type=style&index=1&id=56a09b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a09b26",
  null
  
)

export default component.exports